import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ModalAdditionalQuestionsPage } from './modal-additional-questions.page';

const routes: Routes = [
  {
    path: '',
    component: ModalAdditionalQuestionsPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ModalAdditionalQuestionsPageRoutingModule {}
